import { MessageSquare, FileText, CheckCircle } from "lucide-react";

const steps = [
  {
    icon: MessageSquare,
    step: "1",
    title: "Enquire",
    description: "Get in touch to discuss your learning goals and find the right course for you.",
  },
  {
    icon: FileText,
    step: "2",
    title: "Quote",
    description: "We'll provide you with all the information you need about timings and options.",
  },
  {
    icon: CheckCircle,
    step: "3",
    title: "Book & Complete",
    description: "Secure your place and start your journey to better skills and employability.",
  },
];

export function HowItWorks() {
  return (
    <section id="how-it-works" className="py-16 md:py-24" aria-labelledby="how-it-works-heading">
      <div className="container">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <h2 id="how-it-works-heading" className="text-3xl md:text-4xl font-display font-bold text-secondary mb-4">
            How It Works
          </h2>
          <p className="text-lg text-muted-foreground">
            Getting started is simple
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, index) => (
            <div
              key={step.step}
              className="relative flex flex-col items-center text-center animate-fade-in-up"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              {/* Connector line for desktop */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-primary/50 to-primary/10" aria-hidden="true" />
              )}
              
              <div className="relative mb-6">
                <div className="w-20 h-20 rounded-full bg-gradient-hero flex items-center justify-center shadow-button">
                  <step.icon className="h-8 w-8 text-primary-foreground" aria-hidden="true" />
                </div>
                <span className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-secondary text-secondary-foreground flex items-center justify-center text-sm font-bold">
                  {step.step}
                </span>
              </div>
              
              <h3 className="text-xl font-display font-bold text-secondary mb-2">{step.title}</h3>
              <p className="text-muted-foreground max-w-xs">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}